<template>
  <div class="pagination">
    <pg-container md="3" sm="4" xs="12" cls="pagination-showing">
      Showing <strong>{{ ($pagination.page - 1) * $pagination.perPage + 1 }} - {{ $pagination.page * $pagination.perPage > $pagination.total ? $pagination.total : $pagination.page * $pagination.perPage }}</strong> of {{ $pagination.total }} records
    </pg-container>
    <pg-container md="9" sm="8" xs="12" cls="pagination-links">
      <pg-container md="6" sm="12" cls="align-center">
        <ul>
          <li>
            <a @click.prevent="setPage($pagination.page - 1)" :class="{ 'pagination-link': true, 'disabled': $pagination.page == 1 }" href="#">
              <i class="pg-arrow_left"></i>
            </a>
          </li>
          <li v-for="p in pages">
            <a @click.prevent="setPage(p)" :class="{ 'pagination-link': true, 'active': p === $pagination.page }" href="#">{{ p }}</a>
          </li>
          <li>
            <a @click.prevent="setPage($pagination.page + 1)" :class="{ 'pagination-link': true, 'disabled': $pagination.page == pagesTotal() }" href="#">
              <i class="pg-arrow_right"></i>
            </a>
          </li>
        </ul>
      </pg-container>
      <pg-container md="6" sm="12">      
        <ul>
          <li v-for="p in [30, 50, 100, 500]">
            <a @click.prevent="setPerPage(p)" :class="{ 'pagination-link': true, 'active': p === $pagination.perPage }" href="#">{{ p }}</a>
          </li>
        </ul>
      </pg-container>      
    </pg-container>   
  </div>
</template>

<script>

  export default {
    name: 'Pagination',
    props: {
      fetch: {
        type: Function,
        default: () => {}
      }
    },
    data: () => ({
      pages: [ 1 ]
    }),
    created() {
      this.$pagination.bus.$on('update', () => {
        this.pages = this.calcPages();
      });
    },
    methods: {
      setPerPage(perPage) {
        this.$pagination.options.perPage = perPage;
        this.fetch();
      },
      setPage(page) {
        this.$pagination.page = page;        
        this.fetch();
      },
      pagesTotal() {
        const mod = this.$pagination.total % this.$pagination.perPage;
        return parseInt(this.$pagination.total / this.$pagination.perPage) + (mod > 0 ? 1 : 0);
      },
      calcPages() {
        const pages = [];        
        const pagesTotal = this.pagesTotal();
        const page = this.$pagination.page;

        if (page == 1) {
          pages.push(page);
        } else
        if (page == 2) {
          pages.push(page - 1);
          pages.push(page);
        } else
        if (page == 3) {              
          pages.push(page - 2);
          pages.push(page - 1);
          pages.push(page);
        } else
        if (page > 3) {
          pages.push(1);
          pages.push(page - 2);
          pages.push(page - 1);
          pages.push(page);              
        }

        const remaining = pagesTotal - this.$pagination.page;

        if (remaining == 1) {
          pages.push(page + 1);
        } else
        if (remaining == 2) {
          pages.push(page + 1);
          pages.push(page + 2);
        } else
        if (remaining > 2) {
          pages.push(page + 1);
          pages.push(page + 2);
          pages.push(pagesTotal);
        }

        return pages;
      }
    }
  }
</script>

<style>
  .pagination {
    margin-top: 0;
    margin-bottom: 0;
    width: 100%;
  }

  .pagination-showing {
    font-size: 11px;
    padding: 0 33px;
    color: #626262;    
  }

  .pagination-links, .pagination-per-page {
    text-align: right;
    float: left;
    padding: 0 33px;
  }

  .pagination-links .small {
    color: #626262;
    opacity: 0.5;
  }

  .pagination ul li {
    display: inline;
    padding-left: 10px;
    padding-right: 10px;
  }

  .pagination ul li a {
    color: #626262;
    opacity: 0.5;
    font-size: 11px;    
  }
  
  .pagination ul li a.disabled {
    opacity: 0.2;
    cursor: default;
  }

  .pagination ul li a.active {
    font-weight: bold;
    color: #626262;
    opacity: 1;
  }
</style>


// WEBPACK FOOTER //
// pagination.vue?345d4c74